import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "availableTimes",
  class: "ts-wrapper"
}
const _hoisted_2 = { class: "ts-options flex-row flex-justify-sb" }
const _hoisted_3 = {
  class: "slot-view",
  id: "viewOptions"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "optBg" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Best ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Show ", -1)
const _hoisted_7 = { class: "flex-row flex-align-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Edit Rates", -1)
const _hoisted_9 = {
  key: 1,
  class: "ts-list flex-col"
}
const _hoisted_10 = { class: "window-title" }
const _hoisted_11 = { class: "exp-menu-table" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("tr", { class: "fw-medium" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Rate"),
  /*#__PURE__*/_createElementVNode("th", null, "Current"),
  /*#__PURE__*/_createElementVNode("th", null, "New")
], -1)
const _hoisted_13 = ["value", "onChange", "onKeydown"]
const _hoisted_14 = { class: "exp-menu-buttons flex-row flex-justify-end" }
const _hoisted_15 = { class: "window-title" }
const _hoisted_16 = { class: "exp-menu-table" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", { class: "fw-medium" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Rate"),
  /*#__PURE__*/_createElementVNode("th", null, "Price"),
  /*#__PURE__*/_createElementVNode("th", null, "Participants")
], -1)
const _hoisted_18 = ["value", "onChange"]
const _hoisted_19 = { class: "exp-menu-buttons flex-row flex-justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_button = _resolveComponent("toggle-button")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_time_slot = _resolveComponent("time-slot")!
  const _component_si_currency = _resolveComponent("si-currency")!
  const _component_order_menu = _resolveComponent("order-menu")!
  const _component_number_ticker = _resolveComponent("number-ticker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOption('matched'))),
          class: _normalizeClass({ selected: _ctx.viewOption == 'matched' }),
          id: "matchedOption"
        }, [
          _hoisted_5,
          _createTextVNode("Matched")
        ], 2),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleOption('all'))),
          class: _normalizeClass({ selected: _ctx.viewOption == 'all' }),
          id: "allOption"
        }, [
          _hoisted_6,
          _createTextVNode("All")
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_toggle_button, {
          checked: _ctx.editRates,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleEditRates()))
        }, null, 8, ["checked"])
      ])
    ]),
    (_ctx.loadingTimes)
      ? (_openBlock(), _createBlock(_component_small_loader, { key: 0 }))
      : (!_ctx.loadingTimes && _ctx.timeSlots.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeSlots, (ts) => {
              return (_openBlock(), _createBlock(_component_time_slot, {
                key: ts.Value,
                time: ts,
                isSelectedTime: _ctx.selectedTimes.includes(ts.Value) || _ctx.openTime?.Value == ts.Value,
                isLargeGroup: _ctx.isLargeGroup,
                onOnTimeSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openTimeSlot($event)))
              }, null, 8, ["time", "isSelectedTime", "isLargeGroup"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
    (_ctx.showEditRatesMenu)
      ? (_openBlock(), _createBlock(_component_order_menu, {
          key: 2,
          onOnClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCancel()))
        }, {
          menuHeader: _withCtx(() => [
            _createElementVNode("span", _hoisted_10, "Edit rates for " + _toDisplayString(_ctx.openTime?.DisplayName), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("table", _hoisted_11, [
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openTime?.Rates, (r, i) => {
                return _withDirectives((_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, _toDisplayString(r.Name), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_si_currency, {
                      amount: r.Price
                    }, null, 8, ["amount"])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "add-exp-input",
                      value: `$${r.Price.toFixed(2)}`,
                      onChange: ($event: any) => (_ctx.editRatePrice(i, ($event.target as HTMLInputElement).value)),
                      onKeydown: _withKeys(($event: any) => {
									_ctx.editRatePrice(i, ($event.target as HTMLInputElement).value);
									_ctx.doneEditingRatePrices();
								}, ["enter"])
                    }, null, 40, _hoisted_13)
                  ])
                ])), [
                  [_vShow, r.Participants > 0]
                ])
              }), 128))
            ])
          ]),
          menuFooter: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "naked",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCancel()))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btn-highlight",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doneEditingRatePrices()))
              }, "Done")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showLargeGroupMenu)
      ? (_openBlock(), _createBlock(_component_order_menu, {
          key: 3,
          onOnClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onCancel()))
        }, {
          menuHeader: _withCtx(() => [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.openTime?.DisplayName), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("table", _hoisted_16, [
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openTime?.Rates, (r, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, _toDisplayString(r.Name), 1),
                  _createElementVNode("td", null, [
                    (!_ctx.editRates)
                      ? (_openBlock(), _createBlock(_component_si_currency, {
                          key: 0,
                          amount: r.Price
                        }, null, 8, ["amount"]))
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          value: `$${r.Price.toFixed(2)}`,
                          onChange: ($event: any) => (_ctx.editRatePrice(i, ($event.target as HTMLInputElement).value)),
                          class: "add-exp-input"
                        }, null, 40, _hoisted_18))
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_number_ticker, {
                      value: r.Participants,
                      onOnChange: ($event: any) => (_ctx.assignGroupParticipants(i, $event)),
                      onOnEnter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doneAssigningGroupParticipants()))
                    }, null, 8, ["value", "onOnChange"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          menuFooter: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "naked",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onCancel()))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "btn-highlight",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.doneEditingRatePrices()))
              }, "Done")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}